import { Route, BrowserRouter as Router, Routes } from "react-router-dom";
import DashboardLayout from "./components/layout/dashboard-layout";
import { ThemeProvider } from "./components/theme/theme-provider";
import { AuthProvider } from "./context/auth-context";
import Page404 from "./pages/404";
import ForgotPasswordPage from "./pages/auth/forgot-password";
import LoginPage from "./pages/auth/login";
import ProfilePage from "./pages/auth/profile";
import CategoriesPage from "./pages/categories";
import AddCategoryPage from "./pages/categories/add/add";
import { default as CoursePage } from "./pages/courses";
import AddCoursePage from "./pages/courses/add/add";
import DashboardPage from "./pages/dashboard";
import EnquiryPage from "./pages/enquiry";
import AddEnquiryPage from "./pages/enquiry/add/add";
import EnrollPage from "./pages/enrolls";
import AddEnrollmentPage from "./pages/enrolls/add/add";
import LevelsPage from "./pages/levels";
import AddLevelPage from "./pages/levels/add/add";
import SuccessStoriesPage from "./pages/success-stories";
import AddSuccessStoryPage from "./pages/success-stories/add/add";
import TestimonialPage from "./pages/testimonials";
import AddTestimonialPage from "./pages/testimonials/add/add";
import GuestRoutes from "./routes/guest-routes";
import ProtectedRoute from "./routes/protected-routes";

export default function App() {
  return (
    <ThemeProvider defaultTheme="system" storageKey="ui-theme">
      <AuthProvider>
        <Router>
          <Routes>
            <Route
              element={
                <ProtectedRoute>
                  <DashboardLayout />
                </ProtectedRoute>
              }
            >
              <Route
                path="/"
                element={
                  <ProtectedRoute>
                    <DashboardPage />
                  </ProtectedRoute>
                }
              />

              <Route path="/enrollments" element={<EnrollPage />} />
              <Route
                path="/enrollments/:id"
                element={<AddEnrollmentPage isEdit={true} />}
              />
              <Route path="/enquiry" element={<EnquiryPage />} />
              <Route
                path="/enquiry/:id"
                element={<AddEnquiryPage isEdit={true} />}
              />

              <Route path="/courses" element={<CoursePage />} />
              <Route path="/courses/add" element={<AddCoursePage />} />
              <Route
                path="/courses/:id"
                element={<AddCoursePage isEdit={true} />}
              />

              <Route path="/levels" element={<LevelsPage />} />
              <Route path="/levels/add" element={<AddLevelPage />} />
              <Route
                path="/levels/:id"
                element={<AddLevelPage isEdit={true} />}
              />

              <Route path="/course-categories" element={<CategoriesPage />} />
              <Route
                path="/course-categories/add"
                element={<AddCategoryPage />}
              />
              <Route
                path="/course-categories/:id"
                element={<AddCategoryPage isEdit={true} />}
              />

              <Route path="/testimonials" element={<TestimonialPage />} />
              <Route
                path="/testimonials/add"
                element={<AddTestimonialPage />}
              />
              <Route
                path="/testimonials/:id"
                element={<AddTestimonialPage isEdit={true} />}
              />

              <Route path="/success-stories" element={<SuccessStoriesPage />} />
              <Route
                path="/success-stories/add"
                element={<AddSuccessStoryPage />}
              />
              <Route
                path="/success-stories/:id"
                element={<AddSuccessStoryPage isEdit={true} />}
              />

              <Route
                path="/profile"
                element={
                  <ProtectedRoute>
                    <ProfilePage />
                  </ProtectedRoute>
                }
              />
            </Route>

            <Route
              path="/auth/login"
              element={
                <GuestRoutes>
                  <LoginPage />
                </GuestRoutes>
              }
            />
            <Route
              path="/auth/forgot-password"
              element={<ForgotPasswordPage />}
            />

            <Route path="*" element={<Page404 />} />
          </Routes>
        </Router>
      </AuthProvider>
    </ThemeProvider>
  );
}
